export enum ThirdPartSelectors {
    MarketingVideoLibraryLoaderClass = 'section-loader',
    MarketingVideoLibraryLoaderSvgId = 'section-loader-svg',
    ProductCustomerVideoCta = 'product-detail-customer-video-cta-container',
    ProductMediaCarousel = 'product-detail-media-carousel',
    ProductMediaGalleryThumbNails = 'product-detail-media-gallery-thumbnails',
    ProductBanners = 'product-detail-banners-container',
    PurchaseInAppCtaClass = 'purchase-in-app-cta',
    PurchaseInAppFlagClass = 'purchase-in-app-flag',
    PurchaseInAppDescriptionClass = 'purchase-in-app-description',
}
